$ ->
  require('../apps/home/client/index.coffee')()
